var _defs, _rect, _path, _path2, _path3, _rect2, _path4, _rect3, _path5, _rect4, _path6, _rect5, _path7, _rect6, _path8, _rect7, _path9, _rect8, _path10, _rect9, _path11, _rect10, _rect11, _polygon, _rect12, _polygon2, _path12, _rect13, _path13, _rect14, _path14, _rect15, _path15, _rect16, _path16, _rect17, _path17, _rect18, _polygon3, _path18, _rect19, _path19, _rect20, _path20, _rect21, _path21, _rect22, _path22, _rect23, _polygon4, _path23, _rect24, _path24, _rect25, _path25, _rect26, _path26, _rect27, _polygon5, _polygon6, _polygon7, _path27, _rect28, _polygon8, _polygon9, _polygon10, _polygon11, _rect29, _polygon12, _polygon13, _rect30, _rect31, _rect32, _rect33, _polygon14, _rect34, _polygon15, _rect35, _polygon16, _path28, _rect36, _path29, _rect37, _path30, _rect38, _path31, _rect39, _path32, _rect40, _rect41, _polygon17, _polygon18, _rect42, _path33, _rect43, _path34, _path35, _path36, _path37, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _polygon19, _rect58, _polygon20, _rect59, _circle, _path38, _path39, _polygon21, _path40, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _path41, _rect72, _polygon22, _rect73, _rect74, _rect75, _rect76, _rect77, _polygon23, _polygon24, _polygon25, _polygon26, _rect78, _rect79, _rect80, _rect81, _polygon27, _polygon28, _rect82, _rect83, _rect84, _rect85, _path42, _path43, _circle2, _circle3, _path44, _polygon29, _circle4, _circle5, _path45, _circle6, _path46, _path47, _rect86, _path48, _path49, _polygon30, _circle7, _circle8, _circle9, _polygon31, _rect87, _path50, _path51, _path52, _path53, _polygon32, _polygon33, _path54, _path55, _path56, _polygon34, _polygon35, _polygon36, _path57, _path58, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _path59, _path60, _polygon37, _rect94, _rect95, _path61;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\xCE\\xD3\\xC8_1",
    "data-name": "\\u2014\\xCE\\xD3\\xC8_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1100 740",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#f8f7ff;}.cls-3{fill:#ddd6ff;}.cls-4{fill:#c4b8ff;}.cls-5{fill:#ff95a9;}.cls-6{fill:#40327a;}.cls-7{fill:#7760db;}.cls-8{fill:#a796f2;}.cls-9{fill:#ffc359;}.cls-10{fill:#ffc7bd;}.cls-11{fill:#ff9d45;}.cls-12{fill:#ff809f;}.cls-13{fill:#eeebff;}.cls-14{fill:#e5659b;}.cls-15{fill:none;}.cls-16{fill:#8b77e8;}.cls-17{fill:#624ac9;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1100,
    height: 740
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M977.52,624s92.43-60.17,37.05-116.45-71.94-49.3-56-112,80.51-86.06,54.84-133.66c-30.81-57.13-101.07-5-144.73,15-81.18,37.19-80.7-18.41-49.52-70.43S852.57,67.72,780.57,67.72c-78.31,0-250.41,169.22-345.22,286.17-56.75,70-98.1,21.29-92.36-23.67,3.65-28.59,11.25-74.78-6.53-96-30.86-36.9-121.53,78.7-153.54,128.08C57.64,555.55,209.93,624,209.93,624Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.06,152.61c3.51-8.05,4.64-14.23,2.14-19.32-7.4-15.08-45.13-17.5-69.3-2.82-33.71,20.47-42.62,75.14-27.19,87.28C201.66,231.88,259.91,194.19,278.06,152.61Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.7,640.05h0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 518.7,
    y: 639.05,
    width: 285.08,
    height: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M734.94,655.29h0Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 734.94,
    y: 654.29,
    width: 124.04,
    height: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M469.9,655.29h0Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 469.9,
    y: 654.29,
    width: 226.88,
    height: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M299.19,655.29h0Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 299.19,
    y: 654.29,
    width: 33.7,
    height: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M342.85,655.29h0Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 342.85,
    y: 654.29,
    width: 10.18,
    height: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M838.42,640.28h0Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 838.42,
    y: 639.28,
    width: 57.97,
    height: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M408,640.05h0Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 408.01,
    y: 639.05,
    width: 87.88,
    height: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M235.46,640.05h0Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 235.46,
    y: 639.05,
    width: 153.68,
    height: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.3,640.05h0Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 190.3,
    y: 639.05,
    width: 26.85,
    height: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 396.68,
    y: 150.7,
    width: 367.49,
    height: 473.34
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "764.17 446.05 764.17 624.04 396.68 624.04 396.68 503.3 764.17 446.05"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 363.75,
    y: 223.63,
    width: 433.34,
    height: 327.48,
    transform: "translate(967.79 -193.05) rotate(90)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "679.39 289.74 656.13 270.55 662.5 262.83 677.9 275.55 710.21 234.89 718.04 241.11 679.39 289.74"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M604,264.53h0Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 603.97,
    y: 263.53,
    width: 30.33,
    height: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.8,264.53h0Z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 501.8,
    y: 263.53,
    width: 90.83,
    height: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M562,279.19h0Z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 561.99,
    y: 278.19,
    width: 72.31,
    height: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M553.3,279.19h0Z"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 553.3,
    y: 278.19,
    width: 4.18,
    height: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.64,279.19h0Z"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 460.64,
    y: 278.19,
    width: 82.33,
    height: 2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.64,293.85h0Z"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 460.64,
    y: 292.85,
    width: 117.67,
    height: 2
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "679.39 366.36 656.13 347.16 662.5 339.45 677.9 352.16 710.21 311.51 718.04 317.73 679.39 366.36"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M501.8,341.15h0Z"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 501.8,
    y: 340.15,
    width: 132.5,
    height: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.64,341.15h0Z"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 460.64,
    y: 340.15,
    width: 30.83,
    height: 2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.64,355.81h0Z"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 460.64,
    y: 354.81,
    width: 160.5,
    height: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M519,370.47h0Z"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 518.99,
    y: 369.47,
    width: 3.32,
    height: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.64,370.47h0Z"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 460.64,
    y: 369.47,
    width: 52.18,
    height: 2
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "679.39 442.98 656.13 423.78 662.5 416.07 677.9 428.78 710.21 388.13 718.04 394.35 679.39 442.98"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.64,417.76h0Z"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 460.64,
    y: 416.76,
    width: 173.67,
    height: 2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M580.42,432.43h0Z"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 580.42,
    y: 431.43,
    width: 53.88,
    height: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.64,432.43h0Z"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 460.64,
    y: 431.43,
    width: 107.33,
    height: 2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.64,447.09h0Z"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 460.64,
    y: 446.09,
    width: 149,
    height: 2
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "672.13 293.85 665.7 293.85 665.7 283.13 672.13 293.85"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "672.13 294.85 664.7 294.85 664.7 283.13 666.7 283.13 666.7 292.85 672.13 292.85 672.13 294.85"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "706.7 294.85 676.91 294.85 676.91 292.85 704.7 292.85 704.7 262.36 706.7 262.36 706.7 294.85"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M690,253.85h0Z"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 689.95,
    y: 252.85,
    width: 2.94,
    height: 2
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "665.7 258.37 665.7 253.85 686.39 253.85 665.7 258.37"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "666.7 258.37 664.7 258.37 664.7 252.85 686.39 252.85 686.39 254.85 666.7 254.85 666.7 258.37"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "683.51 371.47 664.7 371.47 664.7 366.06 666.7 366.06 666.7 369.47 683.51 369.47 683.51 371.47"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "706.7 371.47 687.22 371.47 687.22 369.47 704.7 369.47 704.7 346.77 706.7 346.77 706.7 371.47"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 704.7,
    y: 338.52,
    width: 2,
    height: 3.62
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "666.7 362.26 664.7 362.26 664.7 329.47 693.51 329.47 693.51 331.47 666.7 331.47 666.7 362.26"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "706.7 448.09 664.7 448.09 664.7 428.72 666.7 428.72 666.7 446.09 704.7 446.09 704.7 439.13 706.7 439.13 706.7 448.09"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 704.7,
    y: 435.8,
    width: 2,
    height: 3.33
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 704.7,
    y: 418.76,
    width: 2,
    height: 12.62
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 704.7,
    y: 416.27,
    width: 2,
    height: 2.5
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 688.22,
    y: 406.09,
    width: 2.92,
    height: 2
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "666.7 414.09 664.7 414.09 664.7 406.09 684.8 406.09 684.8 408.09 666.7 408.09 666.7 414.09"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 664.7,
    y: 510.39,
    width: 2,
    height: 2.74
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "706.7 524.71 664.7 524.71 664.7 516.97 666.7 516.97 666.7 522.71 704.7 522.71 704.7 517.76 706.7 517.76 706.7 524.71"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 704.7,
    y: 490.88,
    width: 2,
    height: 22.25
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "679.39 519.59 656.13 500.4 662.5 492.69 677.9 505.4 710.21 464.74 718.04 470.97 679.39 519.59"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.64,494.38h0Z"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 460.64,
    y: 493.38,
    width: 160.5,
    height: 2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M507.7,509.05h0Z"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 507.7,
    y: 508.04,
    width: 126.6,
    height: 2
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495.64,509.05h0Z"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 495.64,
    y: 508.04,
    width: 3.43,
    height: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.64,509.05h0Z"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 460.64,
    y: 508.04,
    width: 23.33,
    height: 2
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M460.64,523.71h0Z"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 460.64,
    y: 522.71,
    width: 61.67,
    height: 2
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 416.68,
    y: 603.04,
    width: 327.48,
    height: 2
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "490.43 150.7 490.43 200.7 670.43 200.7 670.43 150.7 615.17 150.7 600.96 120.05 559.91 120.05 545.7 150.7 490.43 150.7"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "490.43 150.7 490.43 187.15 670.43 159.11 670.43 150.7 615.17 150.7 600.96 120.05 559.91 120.05 545.7 150.7 490.43 150.7"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 125.57,
    y: 624.04,
    width: 883.68,
    height: 2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M812.45,296.77c-2.94,13.62-7.87,26.74-11.81,40.12-4,13.76-8.13,27.77-8.08,42.12a75.15,75.15,0,0,0,20.28,50.77c5,5.32,10.89,10,14.75,16.17s5.3,14.74,1,20.64c-6.23,8.51-19.56,6.67-28.68,12-11.47,6.69-13.06,23.76-6.52,35.33s36.32,44.64,78.82,36.45c19-3.67,44.81-21.77,44.07-41.13-.76-20.16-20-36.49-19.35-56.65.43-13.2,9.3-24.37,17-35.12s14.85-23.84,11.31-36.57c-5.21-18.75-29.35-24.54-41-40.09-7.52-10-9.18-23.18-9.65-35.7s-.15-25.35-4.32-37.16C860.07,239.3,824.11,242.71,812.45,296.77Z"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 856.12,
    y: 368.8,
    width: 2,
    height: 217.25
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M858.1,431.57l-2-.32c3.23-19.66,25.58-31.88,26.53-32.39l1,1.76C883.39,400.74,861.18,412.9,858.1,431.57Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M856.13,517.12c-2.19-13.27-18-21.94-18.18-22l.95-1.76c.68.37,16.86,9.22,19.2,23.47Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M820.94,578.55h72a0,0,0,0,1,0,0v20.75A24.75,24.75,0,0,1,868.2,624H845.69a24.75,24.75,0,0,1-24.75-24.75V578.55A0,0,0,0,1,820.94,578.55Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M833.73,622.1a25.72,25.72,0,0,1-13.79-22.81v-7.63h2v7.63a23.71,23.71,0,0,0,12.72,21Z"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 820.94,
    y: 585.05,
    width: 72,
    height: 2
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 847.08,
    y: 577.55,
    width: 45.86,
    height: 2
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 857.84,
    y: 624.04,
    width: 51.62,
    height: 2
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 198.57,
    y: 624.04,
    width: 92.6,
    height: 2
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 611.74,
    y: 624.04,
    width: 9.4,
    height: 2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 313.75,
    y: 624.04,
    width: 286.32,
    height: 2
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 653.57,
    y: 624.04,
    width: 137.33,
    height: 2
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 176.82,
    y: 624.04,
    width: 7.25,
    height: 2
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 920.07,
    y: 624.04,
    width: 19.5,
    height: 2
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 763.17,
    y: 562.55,
    width: 2,
    height: 46.83
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 763.17,
    y: 346.77,
    width: 2,
    height: 194.45
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 395.68,
    y: 480.22,
    width: 2,
    height: 59.83
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 395.68,
    y: 466.63,
    width: 2,
    height: 4.09
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 395.68,
    y: 413.56,
    width: 2,
    height: 48.16
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "671.43 201.7 575.88 201.7 575.88 199.7 669.43 199.7 669.43 150.7 671.43 150.7 671.43 201.7"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 506.65,
    y: 199.7,
    width: 58.36,
    height: 2
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "765.17 228.02 763.17 228.02 763.17 151.7 734.22 151.7 734.22 149.7 765.17 149.7 765.17 228.02"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 711.22,
    y: 149.7,
    width: 14.34,
    height: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 580.43,
    cy: 138.22,
    r: 8.54,
    transform: "translate(351.02 689.01) rotate(-80.78)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M589.52,141.1l-1.9-.6a7.64,7.64,0,0,0,.35-2.28,7.54,7.54,0,0,0-14.31-3.33l-1.8-.88A9.55,9.55,0,0,1,590,138.22,9.37,9.37,0,0,1,589.52,141.1Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M580.43,147.76a9.55,9.55,0,0,1-9.54-9.54v-.28l2,.06v.22a7.55,7.55,0,0,0,7.54,7.54,7.42,7.42,0,0,0,2.3-.36l.62,1.9A9.33,9.33,0,0,1,580.43,147.76Z"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "666.7 498.22 664.7 498.22 664.7 482.71 689.68 482.71 689.68 484.71 666.7 484.71 666.7 498.22"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.86,396.1a9,9,0,1,1,9-9A9,9,0,0,1,97.86,396.1Zm0-16a7,7,0,1,0,7,7A7,7,0,0,0,97.86,380.1Z"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 903.11,
    y: 154.01,
    width: 2,
    height: 8.57
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 903.11,
    y: 205.44,
    width: 2,
    height: 8.57
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 890.25,
    y: 157.45,
    width: 2,
    height: 8.57,
    transform: "translate(38.53 467.29) rotate(-30)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 915.96,
    y: 201.99,
    width: 2,
    height: 8.57,
    transform: "translate(19.7 486.07) rotate(-30)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 880.84,
    y: 166.87,
    width: 2,
    height: 8.57,
    transform: "translate(292.68 849.25) rotate(-60)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 925.37,
    y: 192.58,
    width: 2,
    height: 8.57,
    transform: "translate(292.73 900.73) rotate(-60)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 874.11,
    y: 183.01,
    width: 8.57,
    height: 2
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 925.53,
    y: 183.01,
    width: 8.57,
    height: 2
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 877.55,
    y: 195.87,
    width: 8.57,
    height: 2,
    transform: "translate(19.69 467.22) rotate(-29.99)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 922.09,
    y: 170.15,
    width: 8.57,
    height: 2,
    transform: "translate(38.5 486.02) rotate(-29.99)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 886.96,
    y: 205.28,
    width: 8.57,
    height: 2,
    transform: "translate(267.04 875.04) rotate(-60.01)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 912.68,
    y: 160.74,
    width: 8.57,
    height: 2,
    transform: "translate(318.47 875.04) rotate(-60.01)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M455.4,108.72h-2a14,14,0,0,0-14-14v-2a14,14,0,0,0,14-14h2a14,14,0,0,0,14,14v2A14,14,0,0,0,455.4,108.72ZM445,93.72a16.08,16.08,0,0,1,9.43,9.43,16.08,16.08,0,0,1,9.43-9.43,16.08,16.08,0,0,1-9.43-9.43A16.08,16.08,0,0,1,445,93.72Z"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 489.43,
    y: 150.7,
    width: 2,
    height: 51.77
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "360.07 235.95 371.09 234.06 384.98 291.91 366.39 295.11 360.07 235.95"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 177.68,
    y: 277.75,
    width: 273.33,
    height: 14.97,
    transform: "translate(-60.62 86.3) rotate(-14.27)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 173.99,
    y: 263.24,
    width: 273.33,
    height: 14.97,
    transform: "translate(-57.15 84.94) rotate(-14.27)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 170.29,
    y: 248.73,
    width: 273.33,
    height: 14.97,
    transform: "translate(-53.69 83.58) rotate(-14.27)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 134.32,
    y: 290.26,
    width: 22.46,
    height: 44.92,
    transform: "translate(-72.6 45.53) rotate(-14.27)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 156.09,
    y: 284.73,
    width: 22.46,
    height: 44.92,
    transform: "translate(-70.57 50.73) rotate(-14.27)"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "510.86 219.8 437.56 215.27 448.63 258.8 510.86 219.8"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "488.85 233.6 448.63 258.81 444.95 244.29 487.54 228.47 488.85 233.6"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "510.86 219.8 488.85 233.6 487.54 228.47 510.86 219.8"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "510.86 219.8 487.54 228.47 484.93 218.19 510.86 219.8"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 159.78,
    y: 314.21,
    width: 22.46,
    height: 14.97,
    transform: "translate(-74.03 52.09) rotate(-14.27)"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 138.01,
    y: 319.75,
    width: 22.46,
    height: 14.97,
    transform: "translate(-76.07 46.89) rotate(-14.27)"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 225.2,
    y: 287.22,
    width: 214.13,
    height: 2,
    transform: "translate(-60.83 90.87) rotate(-14.28)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 173.93,
    y: 322.14,
    width: 43.54,
    height: 2,
    transform: "translate(-73.67 58.26) rotate(-14.28)"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "139.48 338.48 131.79 308.24 133.73 307.75 140.93 336.04 170.65 328.49 171.14 330.42 139.48 338.48"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "130.22 302.06 127.92 293 150.65 287.22 151.15 289.16 130.35 294.45 132.16 301.57 130.22 302.06"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 176.44,
    y: 282.06,
    width: 2,
    height: 38.75,
    transform: "translate(-68.83 53.05) rotate(-14.27)"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 156.76,
    y: 313.02,
    width: 2,
    height: 4.26,
    transform: "translate(-72.82 48.61) rotate(-14.27)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 153.87,
    y: 298.01,
    width: 2,
    height: 11.55,
    transform: "translate(-70.12 47.56) rotate(-14.27)"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 440.25,
    y: 214.81,
    width: 2,
    height: 29.95,
    transform: "translate(-43.04 115.91) rotate(-14.28)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M318.39,231.38l-5.15-16.5Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M250.91,342.33c3.13-4.23,6.26-8.36,6.38-14.57.28-15.31-6.53-16-5.63-31.32S263.9,282,264.79,266.67a18.62,18.62,0,0,0-.38-5.26,39.41,39.41,0,0,1-2.9-6.41c-.14-.38-.27-.78-.39-1.17a39.39,39.39,0,1,1,74.72,1.38c-.13.39-.28.76-.42,1.14v0a39.21,39.21,0,0,1-3.15,6.32,19.09,19.09,0,0,0-.56,5.22c.32,15.32,11.68,14.93,12,30.24s-6.51,15.78-6.79,31.08c-.12,6.22,2.86,10.46,5.84,14.81s5.94,8.82,5.82,15.43a34.33,34.33,0,0,1-35,33.68l-35.42-.66a34.3,34.3,0,0,1-33.67-34.95C244.65,350.93,247.79,346.58,250.91,342.33Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 312.51,
    cy: 375.02,
    r: 23.25,
    transform: "matrix(0.66, -0.75, 0.75, 0.66, -175.51, 363.34)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 321.22,
    cy: 300.95,
    r: 13,
    transform: "translate(-116.78 344.6) rotate(-48.82)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M373.59,284.93a9.45,9.45,0,1,1-7,11.39A9.46,9.46,0,0,1,373.59,284.93Z"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "320.46 287.97 375.24 284.69 377.57 303.4 323.67 313.71 320.46 287.97"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 246.24,
    cy: 615.04,
    r: 6.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 320.25,
    cy: 615.04,
    r: 6.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M334.21,300.68l1.5,72.79-46.4,3.1L265,301.65a8,8,0,0,1,7.08-10.45L320.35,288A13,13,0,0,1,334.21,300.68Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 321.22,
    cy: 300.95,
    r: 13,
    transform: "translate(-58.29 77.96) rotate(-12.7)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M335.76,375h-46.5l-2.51,2a34.63,34.63,0,0,0-13.38,27.34v10a14,14,0,0,0,14,14h40.38a14,14,0,0,0,14-14v-13.7A57.71,57.71,0,0,0,335.76,375Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M345.62,325.1a12.88,12.88,0,0,0-1.16-4.53h0l-11.43-25-23.66,10.8,11.43,25h0a13,13,0,0,0,24.79-6.26Z"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 335.56,
    y: 301.17,
    width: 2,
    height: 4.11,
    transform: "translate(-95.57 167.26) rotate(-24.55)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M332.62,340a13.92,13.92,0,0,1-5.5-1.13l.8-1.84a11.88,11.88,0,0,0,5.53.95,12,12,0,0,0,11.17-12.78,11.68,11.68,0,0,0-1.07-4.18l-.42-.93h0l-5-11,1.82-.83,5.87,12.85,0,0a14,14,0,0,1-12.19,18.83Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M262.59,311.38a13,13,0,1,0,3.56-18A13,13,0,0,0,262.59,311.38Z"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "264.81 294.38 223.54 330.55 235.03 345.5 280.63 314.95 264.81 294.38"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 327.75,
    cy: 414.32,
    r: 14
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 287.37,
    cy: 414.32,
    r: 14
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 325.06,
    cy: 486.71,
    r: 11.31
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "313.75 414.32 313.75 486.71 336.34 487.56 341.71 415.38 313.75 414.32"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 290.9,
    y: 262.12,
    width: 22,
    height: 27.09,
    transform: "translate(637.81 508.69) rotate(172.35)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M292.8,290.56a11,11,0,1,0,9.43-12.37A11,11,0,0,0,292.8,290.56Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M286.92,254.5l4.95-.66-1.33-9.91-5,.66a5,5,0,0,0-4.29,5.62h0A5,5,0,0,0,286.92,254.5Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M321.29,220.61l-37.24,5,6.46,48.08,23.13-3.11a16.21,16.21,0,0,0,13.74-19.21Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.58,244.46l-1,.13L281.74,216l29.5-4a14.24,14.24,0,0,1,16,12.21l.07.56-1,.14a39.13,39.13,0,0,0-22.33,11h0a30.55,30.55,0,0,1-17.42,8.57Z"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "319.49 311.22 317.95 288.14 282.75 290.49 319.49 311.22"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "336.34 487.57 326.74 615.53 313.75 615.04 313.75 486.71 336.34 487.57"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M278.92,390.44a5,5,0,1,1-5.18-4.82A5,5,0,0,1,278.92,390.44Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M286.23,399.19a6.91,6.91,0,0,1-2.28-.3h0l-11.48-3.48,1.27-9.79,12-.42a7,7,0,0,1,.49,14Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M235.34,345.28a9.44,9.44,0,1,0-13.19-2.06A9.45,9.45,0,0,0,235.34,345.28Z"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "222.93 344.16 270.3 394.07 277.96 387.67 237.41 332.08 222.93 344.16"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "263.89 387.32 272.47 380.15 237.41 332.08 222.93 344.17 263.89 387.32"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "273.56 412 239.82 613.96 252.55 616.58 300.97 417.64 273.56 412"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M239.74,615h13v9H234.52a2.78,2.78,0,0,1-2.78-2.79h0a2.79,2.79,0,0,1,1.39-2.41Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M320.17,255.55a5.5,5.5,0,0,1-10.87,1.69Z"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 238.28,
    y: 604.65,
    width: 5.86,
    height: 2,
    transform: "translate(-395.94 743.6) rotate(-80.5)"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 312.75,
    y: 457.47,
    width: 2,
    height: 6.47
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 247.34,
    y: 334.82,
    width: 4.28,
    height: 2,
    transform: "translate(-144.68 195.65) rotate(-33.81)"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 252.28,
    y: 323.94,
    width: 26.87,
    height: 2,
    transform: "translate(-135.88 202.82) rotate(-33.81)"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 329.38,
    y: 285.25,
    width: 39.42,
    height: 2,
    transform: "translate(-16.51 21.41) rotate(-3.43)"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 340.09,
    y: 233.93,
    width: 40.41,
    height: 2,
    transform: "translate(-46.82 96.14) rotate(-14.28)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M357.63,233.5a5,5,0,1,1,6.72,2.19A5,5,0,0,1,357.63,233.5Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M347.31,228.64a6.84,6.84,0,0,1,2.2-.68h0l11.88-1.67,3,9.41-10.7,5.43a7,7,0,1,1-6.34-12.48Z"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "262.22 479.92 336.91 479.92 341.71 415.38 273.56 412 262.22 479.92"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 165.93,
    y: 508.05,
    width: 182.84,
    height: 2,
    transform: "translate(-287.2 678.85) rotate(-80.5)"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 312.75,
    y: 491.14,
    width: 2,
    height: 117.4
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.75,615h-13v9H332a2.78,2.78,0,0,0,2.78-2.79h0a2.79,2.79,0,0,0-1.39-2.41Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupBackground);
export default __webpack_public_path__ + "static/media/signup_background.a995469c224bb746d433db41359711b8.svg";
export { ForwardRef as ReactComponent };